export const THEME_PRESETS = [
    {
        id: 'standard',
        label: 'Standard',
        audience: 'Most products',
        character: 'The canonical Staleless look: sidebar, comfortable measure, soft corners.',
    },
    {
        id: 'minimal',
        label: 'Minimal',
        audience: 'Small, literate docs',
        character: 'Almost no chrome. A narrow measure and more line height; typography carries it.',
    },
    {
        id: 'developer',
        label: 'Developer',
        audience: 'API and SDK docs',
        character: 'Dense navigation, a wider measure for code, and square corners.',
    },
    {
        id: 'help-center',
        label: 'Help Center',
        audience: 'Support content',
        character: 'A large search, card-driven pages, and generous corners.',
    },
];
/** The one taken when nobody has chosen — and when a stored value is not one we know. */
export const DEFAULT_PRESET = 'standard';
/**
 * Validate a preset name.
 *
 * Refused rather than coerced. A name we do not know means the caller and this
 * code disagree about what exists, and silently substituting the default hides
 * that disagreement until somebody notices their site looks wrong.
 *
 * Reading is the opposite: `presetOrDefault` falls back, because a row written
 * by an older version must still render a page rather than fail to build.
 */
export function presetProblem(input) {
    const value = input.trim().toLowerCase();
    if (value === '')
        return { ok: false, problem: 'Pick a theme.' };
    if (!THEME_PRESETS.some((preset) => preset.id === value)) {
        return {
            ok: false,
            problem: `"${input}" is not a theme. Pick one of: ${THEME_PRESETS.map((p) => p.id).join(', ')}.`,
        };
    }
    return { ok: true, value };
}
/** What to render with, for a value that has already been stored. */
export function presetOrDefault(value) {
    return THEME_PRESETS.some((preset) => preset.id === value) ? value : DEFAULT_PRESET;
}
//# sourceMappingURL=theme-presets.js.map